export const CONTACT_CREATOR_TRANSLATION_KEY = 'cng-contact_creator'

export const contactCreatorTranslation = {
  fieldBlock: {
    general: `${CONTACT_CREATOR_TRANSLATION_KEY}-field_block-general`,
    hpRoles: `${CONTACT_CREATOR_TRANSLATION_KEY}-field_block-hp_roles`,
    partnerHPRolesList: `${CONTACT_CREATOR_TRANSLATION_KEY}-field_block_partner_hp_roles-list`,
    common: `${CONTACT_CREATOR_TRANSLATION_KEY}-field_block-common`,
    additional: `${CONTACT_CREATOR_TRANSLATION_KEY}-field_block-additional`,
    social: `${CONTACT_CREATOR_TRANSLATION_KEY}-field_block-social`,
    review: `${CONTACT_CREATOR_TRANSLATION_KEY}-field_block-review`,
    contactDuplicate: `${CONTACT_CREATOR_TRANSLATION_KEY}-field_block-contact_duplicate`,
  },
  steps: {
    general: {
      messages: {
        info: `${CONTACT_CREATOR_TRANSLATION_KEY}-steps-general-messages-info`,
        duplicate: `${CONTACT_CREATOR_TRANSLATION_KEY}-steps-general-duplicate`,
      },
      buttons: {
        checkDuplicate: `${CONTACT_CREATOR_TRANSLATION_KEY}-steps-general-buttons-check_duplicate`,
        next: `${CONTACT_CREATOR_TRANSLATION_KEY}-steps-general-buttons-next`,
      },
    },
    hpRoles: {
      buttons: {
        replace: `${CONTACT_CREATOR_TRANSLATION_KEY}-steps-hp_roles-replace`,
      },
    },
    review: {
      buttons: {
        complete: `${CONTACT_CREATOR_TRANSLATION_KEY}-steps-review-complete`,
      },
    },
  },
  warnings: {
    hasDuplicates: `${CONTACT_CREATOR_TRANSLATION_KEY}-warnings-has_duplicates`,
    hasHPRolesDuplicates: `${CONTACT_CREATOR_TRANSLATION_KEY}-warnings-has_hp_roles_duplicates`,
  },
  welcome: {
    title: `${CONTACT_CREATOR_TRANSLATION_KEY}-welcome-title`,
    confirmBtn: `${CONTACT_CREATOR_TRANSLATION_KEY}-welcome-confirm-btn`,
  },
}
